import vHero from "./v-hero.vue";
import vHeroSplitVideoContent from "./split-video/v-hero-split-video-content.vue";
import vHeroSplitVideoEmbed from "./split-video/v-hero-split-video-embed.vue";

export default Vue => {
  Vue.component("v-hero", vHero);
  Vue.component("v-hero-split-video-content", vHeroSplitVideoContent);
  Vue.component("v-hero-split-video-embed", vHeroSplitVideoEmbed);
};
